import React, { Component } from 'react'
import T from '../translate/T'
import { Config } from './_config'
import { Container, Row, Col, Hidden, AlignSM } from './Grid'
import Font from './Font'
import Logo from './Logo'
import Icon from './Icon'

import ModalTerms from '../shared/ModalTerms'

import style from './style.css'

class Footer extends Component {
    state = {
        terms: false
    }
    constructor(props) {
        super(props)
        T.handleUpdate(() => {
            this.forceUpdate()
        })
    }

    // componentWillMount() {
    //     this.componentWillReceiveProps(this.props)
    // }

    // componentWillReceiveProps( np ) {
    //     // if(np.lang)
            // T.setLanguage(np.lang)
    // }

    handleLangChanged(lang) {
        this.props.handleLangChanged(lang)
    }

    render() {
        const lang = T.getLanguage()
        return (
            <div>
                <div className={style.footer}>
                    <Container>
                        <Row>
                            <AlignSM text='center'>
                                <Col size='3'>
                                    <div className={style.boxLogo}>
                                        <div className={style.logo}>
                                            <Logo size='100px' color='#fff' />
                                            <br />
                                            <a style={{cursor: 'pointer', textDecoration: lang === 'pt-BR' ? 'none' : 'underline' }} onClick={(e) => {
                                                e.preventDefault()
                                                this.handleLangChanged('pt-BR')
                                            }}>pt-BR </a>
                                            |
                                            <a style={{cursor: 'pointer', textDecoration: lang === 'en-US' ? 'none' : 'underline' }} onClick={(e) => {
                                                e.preventDefault()
                                                this.handleLangChanged('en-US')
                                            }}> en-us</a>
                                        </div>


                                        <div className={style.icons}>
                                            <span className={style.icon}>
                                                <a href="https://facebook.com/sprinta">
                                                    <Icon name='facebook' />
                                                </a>
                                            </span>
                                            <span className={style.icon}>
                                                <a href="https://instagram.com/instasprinta">
                                                    <Icon name='instagram' />
                                                </a>
                                            </span>
                                        </div>
                                    </div>

                                    <Hidden sm>
                                        <Font size='12' color='#fff' weight='normal'>
                                            © SPRINTA <br /> {T.text('c_copyright')}
                                        </Font>
                                    </Hidden>
                                </Col>




                                <Col size='3'>
                                    <Hidden lg>
                                        <div className={style.spacer} />
                                    </Hidden>
                                    <ul className={style.linksgroup}>
                                        <li><a href="https://sprinta.com.br/conheca/sprinta">{T.text('c_about_sprinta')}</a></li>
                                        <li><a href={Config.linkExplore}>{T.text('c_events')}</a></li>
                                        <li><a href="https://blog.sprinta.com.br/">{T.text('c_blog')}</a></li>
                                        <li><a href="http://sprinta.zendesk.com/hc">{T.text('c_talk_with_us')}</a></li>
                                        <li><a href="#terms"
                                           onClick={(event) => {
                                               event.preventDefault()
                                               this.setState({
                                                    terms: true
                                                })}
                                            }>{T.text('c_sprinta_terms')}</a></li>
                                    </ul>
                                </Col>

                                <Col size='3'>
                                    <Hidden lg>
                                        <div className={style.spacer} />
                                    </Hidden>
                                    <div className={style.titlemenu}>
                                        <Font size='20' color='#fff'>
                                            {T.text('c_athletes')}
                                        </Font>
                                    </div>
                                    <ul className={style.linksgroup}>
                                        <li><a href={Config.linkExplore}>{T.text('c_find_a_event')}</a></li>
                                        <li><a href="https://app.sprinta.com.br/create/event">{T.text('c_create_your_event')}</a></li>
                                        <li><a href="https://sprinta.zendesk.com/hc/pt-br">{T.text('c_support_to_athlete')}</a></li>
                                    </ul>

                                    <div className={style.titlemenu}>
                                        <Font size='20' color='#fff'>
                                            {T.text('c_organizers')}
                                        </Font>
                                    </div>
                                    <ul className={style.linksgroup}>
                                        <li><a href="https://app.sprinta.com.br/conheca/eventos/">{T.text('c_create_your_event')}</a></li>
                                        <li><a href="https://sprinta.zendesk.com/hc/pt-br">{T.text('c_support')}</a></li>
                                    </ul>
                                </Col>



                                <Col size='3'>
                                    <Hidden lg>
                                        <div className={style.spacer} />
                                    </Hidden>
                                    <Font heading='3' color='#fff' style={{lineHeight: '60px'}}>
                                        {T.text('c_make_with')}
                                        <br />
                                        <i className={style.iconlove}> <Icon name='love' /></i>
                                        {T.text('c_for_lovers')}
                                    </Font>
                                </Col>

                                <Hidden lg>
                                    <Col>
                                        <br />
                                        <Font size='12' color='#fff' weight='600'>
                                            © SPRINTA {T.text('c_copyright')}
                                        </Font>
                                    </Col>
                                </Hidden>
                            </AlignSM>
                        </Row>

                        <Row>
                           <Col>
                              <div style={{textAlign: 'center', marginTop: '35px', marginBottom: '-35px'}}>
                                 <Font size='12' color='#fff'>
                                    SPRINTA Comunicação e Marketing LTDA | CNPJ: 23.391.050/0001-42 | Endereço: Rua 11 de Junho, 1271 / 201 - Novo Hamburgo / RS
                                    <br />
                                    Contato: suporte@sprinta.com.br
                                 </Font>
                              </div>
                           </Col>
                        </Row>
                    </Container>
                </div>

                <ModalTerms active={this.state.terms} handleClose={() => {
                      this.setState({
                        terms: false
                     })
                   }} />
            </div>
        )
    }
}

export default Footer



// WEBPACK FOOTER //
// ./src/SPRINTA/Footer/index.js